import { Box, Typography } from '@mui/material'
import { EmptyList } from 'components/core/empty-list'
import { C1Icon } from 'components/core/icons/C1Icon'
import { DocsLink } from 'components/core/links/docs'
import { SpacingVariants } from 'components/core/table-grid'
import { C1TableGrid } from 'components/core/table-grid/C1TableGrid'
import { ProfileList } from 'components/pages/app/users/details/ProfileList'
import { AppUserValue } from 'lib/actions/apps/app-users'
import { IdCard } from 'lucide-react'
import React from 'react'
import { FormattedMessage } from 'react-intl'

type AppUserProfileProps = {
    appUser: AppUserValue,
}

export const AppUserProfile = (
    { appUser }: AppUserProfileProps,
): React.ReactElement | null => {
    return <C1TableGrid
        title={<FormattedMessage id="user_details_profile_attributes" defaultMessage="Profile attributes" />}
        spacingVariant={SpacingVariants.compact}
    >
        {
            appUser.profile?.fields && Object.keys(appUser.profile?.fields).length > 0
                ? <Box px={2}><ProfileList profile={appUser.profile} /></Box>
                : <EmptyList
                    icon={<C1Icon icon={IdCard} />}
                    title={<FormattedMessage id="user_details_profile_empty" defaultMessage="No profile attributes available" />}
                    text={<Typography>
                        <FormattedMessage
                            id="accounts_attributes_info"
                            defaultMessage="Use attributes to add context and organize accounts. "
                        />
                        <DocsLink path="/docs/product/admin/managing-accounts/#account-details">
                            <FormattedMessage
                                id="accounts_attributes_need_help"
                                defaultMessage="Learn more about attributes."
                            />
                        </DocsLink>
                    </Typography>}
                />
        }
    </C1TableGrid>
}
